import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { EspelhoAPI } from '../../apis/EspelhoAPI';

const AddTerminalModal = ({ open, handleClose, selectedEspelho }) => {
    const [number, setNumber] = useState('');
    const [loading, setLoading] = useState(false);

    const [alert, setAlert] = useState({
        visible: false,
        severity: 'error',
        text: ''
    });

    const handleCloseModal = () => {
        setNumber('');
        setAlert({ ...alert, visible: false });
        handleClose();
    }

    const handleSubmit = () => {
        setLoading(true);
        const data = {
            espelhoId: selectedEspelho.Id,
            number: number
        };
        console.log(data);
        EspelhoAPI.createTerminal(data)
            .then((res) => {
                console.log(res);
                handleClose();
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setAlert({
                    visible: true,
                    severity: 'error',
                    text: e?.response?.data
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
        >
            <DialogTitle>Adicionar terminal</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Digite o número para o novo terminal em <strong>{selectedEspelho?.Label}</strong>.
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="number"
                    name="number"
                    label="Número"
                    fullWidth
                    variant="standard"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                />
            </DialogContent>

            {alert.visible &&
                <Box>
                    <Alert severity={alert.severity}>{alert.text}</Alert>
                </Box>
            }

            <DialogActions>
                <Button onClick={handleCloseModal} disabled={loading}>Cancelar</Button>
                <Button onClick={handleSubmit} disabled={loading}>Criar</Button>
            </DialogActions>
        </Dialog>
    )
}
export default AddTerminalModal;